module.exports = __webpack_public_path__ + "static/media/base.870d242e.svg";